import React from 'react';
import style from '../../../css/homepage/Conditions.module.css';

const Privacypolicy = () => {
    return (
        <div>
            <div className={`${style.containerfluid} container-fluid`}>
                <div className="container">
                    <div className={`${style.firstrow} row`}>
                        <h2>
                            Privacy Policy
                        </h2>
                    </div>

                    <div className={`${style.secondrow} row`}>
                        <h6>
                            <a href="">Swingalgo.com</a> "we," "our," or "us" is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our Website.
                        </h6>

                        {/* <h6>
                            Information We Collect:
                            Personal Information: Name, email address, phone number, etc., provided voluntarily by you.
                        </h6>

                        <h6>
                            Usage Data: IP address, browser type, pages visited, and other analytics data.
                        </h6>

                        <h6>
                            How We Use Your Information:
                            To provide and maintain the Website.
                            To communicate with you, including responding to inquiries.
                            To improve the Website and user experience.
                            For marketing and promotional purposes with your consent.
                        </h6>

                        <h6>
                            Sharing Your Information:
                            We do not sell or rent your personal information to third parties.
                            We may share information with service providers who assist us in operating the Website.
                        </h6>

                        <h6>
                            Cookies:
                            We use cookies to enhance your experience on the Website. You can disable cookies in your browser settings.
                        </h6>

                        <h6>
                            Data Security:
                            We implement reasonable security measures to protect your information. However, no method of transmission over the internet is 100% secure.
                        </h6>

                        <h6>
                            Your Rights:
                            You may request access, correction, or deletion of your personal information by contacting us at <a href="">support@Swingalgo.com</a>.
                        </h6>

                        <h6>
                            Third-Party Links:
                            The Website may contain links to third-party websites. We are not responsible for their privacy practices.
                        </h6>

                        <h6>
                            Changes to This Policy:
                            We may update this Privacy Policy from time to time. Any changes will be posted on this page.
                            For any questions about this Privacy Policy, please contact us at <a href="">support@Swingalgo.com</a>.
                        </h6> */}

                        <h6>
                            We may collect the following types of information:
                        </h6>

                        <h6>
                            Personal Information
                        </h6>

                        <h6>
                            We collect personal information that you voluntarily provide to us when you:
                        </h6>

                        <h6>
                            * Register on our Website
                        </h6>

                        <h6>
                            * Subscribe to our newsletter or alerts
                        </h6>

                        <h6>
                            * Contact us for inquiries or support
                        </h6>

                        <h6>
                            * Engage with us on social media platforms
                        </h6>

                        <h6>
                            This may include:
                        </h6>

                        <h6>
                            * Name
                        </h6>

                        <h6>
                            * Email address
                        </h6>

                        <h6>
                            * Phone number
                        </h6>

                        <h6>
                            * Billing or payment information (if applicable)
                        </h6>

                        <h6>
                            * Any other details you provide voluntarily
                        </h6>

                        <h6>
                            Non-Personal Information (Usage Data)
                        </h6>

                        <h6>
                            When you access our Website, we may automatically collect certain information about your interaction with the Website, including:
                        </h6>

                        <h6>
                            * IP address
                        </h6>

                        <h6>
                            * Browser type and version
                        </h6>

                        <h6>
                            * Device type and operating system
                        </h6>

                        <h6>
                            * Pages visited and time spent on each page
                        </h6>

                        <h6>
                            * Referring URL (the page from which you came to our site)
                        </h6>

                        <h6>
                            * Cookies and tracking technologies
                        </h6>

                        <h6>
                            How We Use Your Information
                        </h6>

                        <h6>
                            We use the collected data for the following purposes:
                        </h6>

                        <h6>
                            To Provide & Maintain the Website: Ensuring proper functionality, security, and optimization of the Website.
                        </h6>

                        <h6>
                            To Communicate with You: Responding to inquiries, sending newsletters, transaction confirmations, and service updates.
                        </h6>

                        <h6>
                            For Marketing & Promotions: Sending offers, newsletters, or promotional content (only with your consent).
                        </h6>

                        <h6>
                            To Improve User Experience: Analyzing usage data to enhance website performance and services.
                        </h6>

                        <h6>
                            To Enforce Terms & Conditions: Ensuring compliance with our legal obligations and policies.
                        </h6>

                        <h6>
                            Sharing Your Information
                        </h6>

                        <h6>
                            We do not sell, trade, or rent your personal information to third parties. However, we may share your information with:
                        </h6>

                        <h6>
                            Service Providers: Trusted third-party vendors who help operate our Website (e.g., hosting, analytics, email services, and security).
                        </h6>

                        <h6>
                            Legal Compliance: If required by law, government requests, or to protect our rights, we may disclose your information.
                        </h6>

                        <h6>
                            Cookies & Tracking Technologies
                        </h6>

                        <h6>
                            We use cookies and similar tracking technologies to enhance your experience on our Website. These include:
                        </h6>

                        <h6>
                            Essential Cookies: Required for core website functions.
                        </h6>

                        <h6>
                            Analytics Cookies: Help us understand visitor interactions to improve user experience.
                        </h6>

                        <h6>
                            Marketing Cookies: Used to deliver targeted advertisements and promotions.
                        </h6>

                        <h6>
                            You can manage your cookie preferences in your browser settings. However, disabling cookies may affect some functionalities.
                        </h6>

                        <h6>
                            Data Security
                        </h6>

                        <h6>
                            We implement industry-standard security measures to protect your personal data from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.
                        </h6>

                        <h6>
                            Encryption protocols and security measures safeguard sensitive information.
                        </h6>

                        <h6>
                            Access controls and monitoring help detect unauthorized access.
                        </h6>

                        <h6>
                            In case of a security breach, we will notify affected users promptly.
                        </h6>

                        <h6>
                            Your Rights & Choices
                        </h6>

                        <h6>
                            As a user, you have the following rights regarding your data:
                        </h6>

                        <h6>
                            Access: You can request a copy of the personal data we hold about you.
                        </h6>

                        <h6>
                            Correction: You may request corrections to inaccurate or incomplete data.
                        </h6>

                        <h6>
                            Deletion (Right to be Forgotten): You can request the removal of your data under certain conditions.
                        </h6>

                        <h6>
                            Opt-out of Marketing: You can unsubscribe from promotional emails anytime.
                        </h6>

                        <h6>
                            To exercise your rights, contact us at  <a href="">support@Swingalgo.com</a>.
                        </h6>

                        <h6>
                            Third-Party Links & Services
                        </h6>

                        <h6>
                            Our Website may contain links to third-party websites or services. Please note:
                        </h6>

                        <h6>
                            We are not responsible for the privacy practices of external sites.
                        </h6>

                        <h6>
                            We encourage you to review their privacy policies before sharing any personal information.
                        </h6>

                        <h6>
                            Refund & Cancellation Policy
                        </h6>

                        <h6>
                            No Refunds: All purchases made on our platform are final and non-refundable.
                        </h6>

                        <h6>
                            Cancellation: If you wish to cancel your subscription or service, please contact us before the next billing cycle.
                        </h6>

                        <h6>
                            Refer to our <a href="">Refund & Cancellation Policy</a> for more details.
                        </h6>

                        <h6>
                            Disclaimer & Market Risks
                        </h6>

                        <h6>
                            Investment Risks: Investments in the stock market are subject to market risks. Read all related documents before investing.
                        </h6>

                        <h6>
                            Educational Purpose: Content shared on our platform is for educational purposes only and does not constitute financial advice.
                        </h6>

                        <h6>
                            Past Performance: Historical data does not guarantee future results.
                        </h6>

                        <h6>
                            Refer to our <a href="">Disclaimer</a> for full details.
                        </h6>

                        <h6>
                            Updates to This Privacy Policy
                        </h6>

                        <h6>
                            We may update this Privacy Policy from time to time. Changes will be reflected on this page with an updated "Last Modified" date. Your continued use of the Website constitutes your acceptance of any revisions.
                        </h6>

                        <h6>
                            Contact Us
                        </h6>

                        <h6>
                            If you have any questions or concerns regarding this Privacy Policy, you may contact us at:
                        </h6>

                        <h6>
                            📧 Email:  <a href="">support@Swingalgo.com</a>
                        </h6>

                        <h6>
                            🌐 Website: <a href="">Swingalgo.com</a>
                        </h6>
                    </div>

                    <div className={`${style.thirdrow} row`}>
                        <h5>
                            Last Updated: <span className={style.updatedate}>May 1, 2025</span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacypolicy